import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(2)
  },
  fullWidthDiv: {
    flexGrow: 1
  },
  rootActions: {
    flexGrow: 1,
    marginTop: theme.spacing(2),
    textAlign: 'right'
  },
  card: {
    position: 'relative',
    textAlign: 'center',
    margin: 10,
    marginBottom: 20,
    border: '1px solid rgba(0, 0, 0, 0.12)',
    boxShadow: 'unset',
    padding: 20,
    overflow: 'visible'
  },
  icon: {
    position: 'absolute !important',
    right: 10,
    top: 10,
    zIndex: 1
  },
  divider: {
    marginTop: 10
  },
  body: {
    paddingTop: 20,
    textAlign: 'left'
  },
  actions: {
    bottom: 10,
    right: 10,
    padding: 0,
    textAlign: 'right'
  },
  selectContainer: {
    transform: 'translateY(-13px)',
    width: '100%'
  },
  select: {
    width: '131px'
  },
  button: {
    marginLeft: 2,
    marginRight: 2
  },
  clearFix: {
    clear: 'both',
    display: 'table'
  },
  gutterBottomCardRow: {
    marginBottom: 15
  },
  cardTitle: {
    fontSize: 16
  }
}));

export default useStyles;
